import { render } from "./SkillBox.vue?vue&type=template&id=57c0628e"
import script from "./SkillBox.vue?vue&type=script&lang=js"
export * from "./SkillBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__